import { render, staticRenderFns } from "./ErrorComponent.vue?vue&type=template&id=dc8adbf4"
import script from "./ErrorComponent.vue?vue&type=script&lang=js"
export * from "./ErrorComponent.vue?vue&type=script&lang=js"
import style0 from "./ErrorComponent.vue?vue&type=style&index=0&id=dc8adbf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports